"use client";

import React from "react";
import { useNavigate } from "react-router";
import { Button, Spinner } from "react-bootstrap";
import styles from "./components/auth/LoginForm.module.css";
import { UserContext } from "./components/auth/auth";

interface UserWheel {
    uuid: string;
    date_created: string;
    name: string;
    owner: 'me' | 'client';
}

export default function Home() {
    const navigate = useNavigate();
    const { authorized, wheels, my_clients_wheels } = React.useContext(UserContext);

    const allWheels: UserWheel[] = [
        ...(wheels || []),
        ...(my_clients_wheels || [])
    ];

    // Пока контекст не загружен - показываем спиннер
    if (wheels === undefined && my_clients_wheels === undefined) {
        return (
            <div className={styles.container}>
                <div className={styles.loginCard}>
                    <div className={styles.logoSection}>
                        <img
                            src="/splash400.png"
                            alt="Artifacts"
                            className={styles.logo}
                            style={{ width: 200, height: 200, objectFit: 'contain' }}
                        />
                    </div>
                    <h2 className={styles.title}>Загрузка</h2>
                    <div className={styles.form}>
                        <Spinner animation="border" variant="primary" />
                        <p style={{ marginTop: '16px' }}>Загрузка ваших данных...</p>
                    </div>
                </div>
            </div>
        );
    }

    // Если есть колеса - редиректим на /my
    React.useEffect(() => {
        if (allWheels.length > 0) {
            navigate('/my');
        }
    }, [wheels, my_clients_wheels, navigate]);

    if (allWheels.length > 0) {
        return null;
    }

    const handleCreateWheel = () => {
        navigate('/my');
    };

    if (!authorized) {
        return (
            <div className={styles.container}>
                <div className={styles.loginCard}>
                    <p>Проверка авторизации...</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.loginCard}>
                <div className={styles.logoSection}>
                    <img
                        src="/splash400.png"
                        alt="Artifacts"
                        className={styles.logo}
                        style={{ width: 400, height: 400, objectFit: 'contain' }}
                    />
                </div>

                <h2 className={styles.title}>Ваши Артефакты</h2>
                <p className={styles.subtitle}>Создайте новое хранилище Артефактов</p>

                <div className={styles.form} style={{ marginTop: '20px' }}>
                    <p className={styles.instruction}>У вас пока нет Артефактов</p>
                    <Button
                        variant="primary"
                        onClick={handleCreateWheel}
                        className={styles.button}
                    >
                        Начать
                    </Button>
                </div>
            </div>
        </div>
    );
}
